import styled from 'styled-components'

export const Image = styled.img`
  width: 100%;
  height: auto;
  display: block;
  border-radius: ${props => props.borderRadius};
`
